import React from 'react';
import { Spinner } from 'react-activity';
import 'react-activity/dist/Spinner.css';
import styled from 'styled-components';

// Define a reusable styled component with margin-top
const SpinnerWrapper = styled.div`
  margin-top: ${(props) => props.marginTop || '40vh'};
  width: ${(props) => props.width || '73vw'};
  text-align: center;
  display: flex !important;
  justify-content: center !important;
`;

const Loader = ({ marginTop, width }) => {
  return (
    <SpinnerWrapper marginTop={marginTop} width={width}>
      <Spinner color="#864629" size={40} speed={1} animating={true} />
    </SpinnerWrapper>
  );
};

export default Loader;
